<template>
    <div class="game-manage-container">
        <el-tabs v-model="activeName" class="game-tabs">
            <!-- 音频转换 Tab -->
            <el-tab-pane label="音频转换" name="音频转换" v-loading="loading.show" :element-loading-text="loading.text"
                :element-loading-spinner="loading.spinner">
                <div class="settings-card">
                    <div class="settings-section">
                        <div class="settings-title">
                            <i class="el-icon-setting"></i>
                            <span>语音设置</span>
                        </div>
                        <el-form label-width="100px" class="settings-form">
                            <el-form-item label="音色设置">
                                <el-select v-model="selectValues[0].VoiceType" placeholder="请选择音色" size="small"
                                    @change="handleSelectChangeClick">
                                    <el-option v-for="(option, index) in SoundSet.voiceType" :key="'op' + index"
                                        :label="option.label" :value="option.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="音量设置">
                                <el-slider v-model="SoundSet.volume" :min="0" :max="10" show-input
                                    @change="handleSelectChangeClick"></el-slider>
                            </el-form-item>
                            <el-form-item label="语速设置">
                                <el-slider v-model="SoundSet.Speed" :min="-5" :max="5" show-input
                                    @change="handleSelectChangeClick"></el-slider>
                            </el-form-item>
                        </el-form>
                    </div>

                    <div class="settings-section">
                        <div class="settings-title">
                            <i class="el-icon-document"></i>
                            <span>产品设置</span>
                        </div>
                        <el-form label-width="100px" class="settings-form">
                            <el-form-item label="产品级别">
                                <el-select v-model="selectValues[1].ProductLevel" placeholder="请选择产品级别" size="small"
                                    @change="handleClick">
                                    <el-option v-for="(option, index) in ProductLevel" :key="'op' + index"
                                        :label="option.label" :value="option.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="产品单元">
                                <el-select v-model="selectValues[1].ProductUnit" placeholder="请选择产品单元" size="small"
                                    @change="handleClick">
                                    <el-option v-for="(option, index) in ProductUnit" :key="'op' + index"
                                        :label="option.label" :value="option.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="单元">
                                <el-select v-model="selectValues[2].ProductUnit" placeholder="请选择产品单元" size="small"
                                    @change="handleClick">
                                    <el-option v-for="(option, index) in ProductUnit" :key="'op' + index"
                                        :label="option.label" :value="option.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="是否覆盖">
                                <el-switch v-model="isSaveNew" active-text="是" inactive-text="否"></el-switch>
                            </el-form-item>
                        </el-form>
                    </div>

                    <div class="settings-section">
                        <div class="settings-title">
                            <i class="el-icon-edit"></i>
                            <span>单词转换</span>
                        </div>
                        <el-form label-width="100px" class="settings-form">
                            <el-form-item label="单词">
                                <el-input v-model="word" placeholder="请输入要转音单词" size="small"
                                    style="max-width: 300px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-headset" @click="createAndListen">试听</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </el-tab-pane>

            <!-- 单词信息 Tab -->
            <el-tab-pane label="单词信息" name="单词信息">
                <!-- 筛选区域 -->
                <div class="filter-section">
                    <el-form :inline="true" class="filter-form">
                        <el-form-item label="系列">
                            <el-select v-model="selectValues[3].ProductSeries" placeholder="请选择产品系列" size="small"
                                @change="handleClick">
                                <el-option v-for="(option, index) in ProductSeries" :key="'op' + index"
                                    :label="option.label" :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="级别">
                            <el-select v-model="selectValues[1].ProductLevel" placeholder="请选择产品级别" size="small"
                                @change="handleClick">
                                <el-option v-for="(option, index) in ProductLevel" :key="'op1' + index"
                                    :label="option.label" :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单元">
                            <el-select v-model="selectValues[2].ProductUnit" placeholder="请选择产品单元" size="small"
                                @change="handleClick">
                                <el-option v-for="(option, index) in ProductUnit" :key="'op2' + index"
                                    :label="option.label" :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 工具栏 -->
                <div class="toolbar-section">
                    <el-upload class="upload-inline" action="" :on-change="handleChange" :auto-upload="false"
                        :show-file-list="false" :file-list="fileList">
                        <el-button size="small" type="primary" icon="el-icon-upload2">选取文件</el-button>
                    </el-upload>
                    <el-button size="small" type="success" icon="el-icon-upload" @click="uploadFile"
                        :loading="uploadloading">上传</el-button>
                    <el-button size="small" type="success" icon="el-icon-download" @click="downloadFile"
                        :loading="downloadloading">下载</el-button>
                    <el-button size="small" type="success" icon="el-icon-microphone" @click="batchGenerateSounds"
                        :loading="downloadloading">批量语音</el-button>
                </div>

                <!-- 表格区域 -->
                <div class="table-section">
                    <el-table
                        :data="wordList.filter(data => !seachWord || data.word.toLowerCase().includes(seachWord.toLowerCase()))"
                        stripe :height="mainHeight - 340" v-loading="loading.show"
                        :default-sort="{ prop: 'word', order: 'ascending' }" class="word-table">
                        <el-table-column prop="word" label="单词" sortable width="180"></el-table-column>
                        <el-table-column prop="cn" label="中文释义" sortable min-width="250"></el-table-column>
                        <el-table-column prop="catalog" label="词汇分类" sortable width="150"></el-table-column>
                        <el-table-column prop="difficulty" label="难度" sortable width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag
                                    :type="scope.row.difficulty === '简单' ? 'success' : scope.row.difficulty === '中等' ? 'warning' : 'danger'"
                                    size="small">
                                    {{ scope.row.difficulty }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sameWords" label="同义词" min-width="200"></el-table-column>
                        <el-table-column label="操作" width="180" align="center">
                            <template slot="header">
                                <el-input v-model="seachWord" size="mini" placeholder="输入关键字搜索"
                                    prefix-icon="el-icon-search" clearable />
                            </template>
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" icon="el-icon-headset"
                                    @click="handleListenClick(scope.row.id)" circle></el-button>
                                <el-button type="success" size="mini" icon="el-icon-edit" @click="editWord(scope.row)"
                                    circle></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 编辑对话框 -->
                <el-dialog v-loading="loading1" title="修改信息" :visible.sync="centerDialogVisible" width="50%"
                    :center="true" custom-class="edit-dialog">
                    <el-form label-position="right" label-width="80px" :model="editModel">
                        <el-form-item label="单词">
                            <el-input v-model="editModel.word" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="中文释义">
                            <el-input v-model="editModel.cn" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="难度">
                            <el-rate v-model="editModel.difficulty" :max="3" style="padding-top: 10px;"></el-rate>
                        </el-form-item>
                        <el-form-item label="同义词">
                            <el-input v-model="editModel.sameWords" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="词汇分类">
                            <el-tag v-if="editModel && editModel.catalog" style="margin-left: 5px;" size="small"
                                v-for="(cata, index) in editModel.catalog.split('/')" :key="index" type="warning">{{
                                    cata }}</el-tag>
                        </el-form-item>
                        <el-form-item label="词汇路径">
                            <el-tag style="margin-left: 5px;" size="small" type="info">{{ editModel.soundPath
                                }}</el-tag>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="centerDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="saveWord">保存</el-button>
                    </span>
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import api from '@/utils/api'
import { Howl } from 'howler'
export default {
    name: 'GameManage',
    data () {
        return {
            mainHeight: window.innerHeight,
            activeName: '单词信息',
            loading1: false,
            centerDialogVisible: false,
            editModel: { catalog: '' },
            myAudio: null,
            seachWord: '',
            word: 'Convert',
            currentFile: null,
            isSaveNew: false,
            downloadloading: false,
            uploadloading: false,
            fileList: [],
            loading: {
                show: false,
                text: '转换中...',
                spinner: 'el-icon-loading'
            },
            selectValues: [{ VoiceType: 101051 }, { ProductLevel: 0 }, { ProductUnit: 1 }, { ProductSeries: 1 }],
            ProductLevel: [
                { label: '预备级', value: 0 },
                { label: '一级', value: 1 },
                { label: '二级', value: 2 },
                { label: '三级', value: 3 }
            ],
            ProductSeries: [
                { label: 'O系列', value: 0 },
                { label: '128系列', value: 2 },
                { label: '168系列', value: 1 }
            ],
            ProductUnit: [],
            wordList: [],
            SoundSet: {
                volume: 5, // 音量（0-10）
                Speed: 0, // 语速（-5到5）
                voiceType: [{ label: '英文男声', value: 101050 }, { label: '英文女声', value: 101051 }] // 音色ID（如101016为“智聆-亲切女声”）
            }
        }
    },
    created () {
        this.getWordList()
        this.ProductLevel.splice(0, 0, { label: '全部', value: -1 })
        this.ProductUnit.push({ label: '全部', value: -1 })
        for (let i = 1; i <= 16; i++) {
            this.ProductUnit.push({ label: 'Unit ' + i, value: i })
        }
    },
    methods: {
        getDiffculty (str) {
            // 获取难度数据
            if (str === '简单') {
                return 1
            } else if (str === '中等') {
                return 2
            } else if (str === '困难') {
                return 3
            }
        },
        editWord (row) {
            // row.difficulty = this.getDiffculty(row.difficulty)
            this.editModel = Object.assign({}, row)
            this.editModel.difficulty = this.getDiffculty(row.difficulty)
            this.centerDialogVisible = true
        },
        saveWord () {
            this.loading1 = true
            this.$axios.post(api.updateWord, this.editModel).then(res => {
                if (res.data.success === true) {
                    this.$message.success('保存成功')
                    this.centerDialogVisible = false
                    this.getWordList()
                } else {
                    this.$message.error(res.data.result)
                }
                this.loading1 = false
            }).catch(() => {
                this.loading1 = false
            })
        },
        getWordList () {
            this.loading.show = true
            this.$axios.post(api.getWordList, {
                productSeries: this.selectValues[3].ProductSeries,
                productLevel: this.selectValues[1].ProductLevel,
                productUnit: this.selectValues[2].ProductUnit,
                word: this.seachWord
            }).then(res => {
                if (res.data.success === true) {
                    this.wordList = res.data.result
                } else {
                    this.$message.error(res.data.result)
                }
                this.loading.show = false
            }).catch(() => {
                this.loading.show = false
            })
        },
        createAndListen () {
            this.loading.show = true // 显示loading
            console.log('isSaveNew', this.isSaveNew)
            this.$axios.post(api.convertToSound, { word: this.word, IsSaveNew: this.isSaveNew, productSeries: this.selectValues[3].ProductSeries, productLevel: this.selectValues[1].ProductLevel, productUnit: this.selectValues[2].ProductUnit, setting: { VoiceType: this.selectValues[0].VoiceType, volume: this.SoundSet.volume, speed: this.SoundSet.Speed } })
                .then(res => {
                    if (res.data.result.success !== 0) {
                        this.loading.text = '语音播放中...'
                        this.loading.spinner = 'el-icon-microphone'
                        console.log(res.data.result.base64Data.length)
                        var blobUrl = this.base64ToBlobUrl(res.data.result.base64Data)
                        var sound = new Howl({
                            src: [blobUrl],
                            format: ['mp3'],
                            htm5: true, // 使用HTML5音频
                            onend: () => {
                                URL.revokeObjectURL(blobUrl)
                                this.loading.show = false // 播放完成后隐藏loading
                            } // 播放后释放内存
                        })
                        sound.play()
                    } else {
                        this.$message.error(res.data.result.message)
                    }
                }
                )
        },
        // 将Base64转为Blob URL
        base64ToBlobUrl (base64) {
            const byteString = atob(base64)
            const ab = new ArrayBuffer(byteString.length)
            const ia = new Uint8Array(ab)

            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }

            const blob = new Blob([ab], { type: 'audio/mpeg' })
            return URL.createObjectURL(blob) // 返回Blob URL
        },
        handleSelectChangeClick () {
            this.isSaveNew = true
            // Handle next game logic here
        },
        handleClick () {
            this.getWordList()
        },
        handleListenClick (id, word) {
            // Handle listen button click logic here
            console.log('id', id)
            // 加载音频数据
            this.loading.show = true
            if (word) {
                this.word = word
                this.createAndListen()
            } else {
                this.playAudio(id)
            }
        },
        playAudio (id) {
            if (this.myAudio) {
                this.myAudio.unload()// 释放音频资源
                this.myAudio = null
            }
            this.$axios.post(api.getMp3, { id: id })
                .then(res => {
                    if (res.data.success === false) {
                        this.loading.show = false
                        this.$message.error('该单词暂无音频，请先转换生成音频')
                        return
                    }
                    var blobUrl = this.base64ToBlobUrl(res.data.result.base64Data)
                    this.myAudio = new Howl({
                        src: [blobUrl],
                        html5: true, // 强制使用HTML5 Audio
                        onend: function () {
                            console.log('Finished!')
                        }
                    })
                    this.myAudio.play()
                })
        },
        batchGenerateSounds () {
            this.loading.show = true
            this.$axios.post(api.wordsToMp3, { productSeries: this.selectValues[3].ProductSeries, productLevel: this.selectValues[1].ProductLevel, productUnit: -1 })
                .then(res => {
                    if (res.data.result.success === true) {
                        if (res.data.result.counts === 0) {
                            this.$message.info('没有需要生成音频的单词')
                        } else {
                            this.$message.success('共生成音频' + res.data.result.counts + '个')
                        }
                    } else {
                        this.$message.error(res.data.result.message)
                    }
                    this.loading.show = false
                }).catch(() => {
                    this.loading.show = false
                })
        },
        uploadFile () {
            var file = this.currentFile
            if (file === null) {
                this.$message({ message: '请先选择上传文件', type: 'warning' })
                return
            }
            var formData = new FormData()
            formData.append('file', file.raw)
            formData.append('productLevel', this.selectValues[1].ProductLevel)
            formData.append('productSeries', this.selectValues[3].ProductSeries)
            this.uploadloading = true
            var _this = this
            return this.$axios.post(api.importExcel, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(res => {
                    if (res.data.result === 'SUCCESS') {
                        _this.uploadloading = false
                        _this.$message({ message: file.name + '文件上传成功', type: 'success' })
                        return true
                    } else {
                        _this.uploadloading = false
                        _this.$message({ message: res.data.result, type: 'error' })
                        return false
                    }
                })
                .catch(function (error) {
                    _this.$message({ message: error.message, type: 'error' })
                    _this.uploadloading = false
                    return false
                })
        },
        downloadFile () {
            this.downloadloading = true
            this.$axios.post(api.exportExcel, { productUnit: this.selectValues[1].ProductLevel }, { responseType: 'blob' })
                .then((response) => {
                    console.log(response)
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; application/octet-stream' })
                    const elink = document.createElement('a')
                    elink.download = '单词列表.xlsx'
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href)
                    document.body.removeChild(elink)
                    this.downloadloading = false
                }).catch((error) => {
                    this.downloadloading = false
                    this.$message({
                        message: error
                    })
                })
        },
        handleChange (file, fileList) {
            this.currentFile = file
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.game-manage-container {
    padding: $spacing-lg;
    background: var(--bg-base);
    min-height: calc(100vh - 120px);
}

.game-tabs {
    background: var(--bg-white);
    border-radius: $border-radius-base;
    box-shadow: var(--shadow-base);
    overflow: hidden;

    ::v-deep .el-tabs__header {
        background: var(--gradient-header);
        margin: 0;
        padding: 0 $spacing-lg;
    }

    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }

    ::v-deep .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: $font-size-base;
        color: var(--text-regular);
        padding: 0 $spacing-lg;

        &.is-active {
            color: $primary-color;
            font-weight: 600;
        }

        &:hover {
            color: $primary-color;
        }
    }

    ::v-deep .el-tabs__content {
        padding: $spacing-lg;
    }
}

// 音频转换设置卡片d
.settings-card {
    display: flex;
    flex-direction: column;
    gap: $spacing-lg;
}

.settings-section {
    background: var(--bg-base);
    border-radius: $border-radius-base;
    padding: $spacing-lg;
    border: 1px solid var(--border-lighter);
}

.settings-title {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    font-size: $font-size-md;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: $spacing-md;
    padding-bottom: $spacing-sm;
    border-bottom: 1px solid var(--border-lighter);

    i {
        color: $primary-color;
        font-size: $font-size-lg;
    }
}

.settings-form {
    ::v-deep .el-form-item {
        margin-bottom: $spacing-md;

        &:last-child {
            margin-bottom: 0;
        }
    }

    ::v-deep .el-form-item__label {
        color: var(--text-regular);
        font-weight: 500;
    }
}

// 筛选区域
.filter-section {
    background: var(--bg-base);
    border-radius: $border-radius-base;
    padding: $spacing-md $spacing-lg;
    margin-bottom: $spacing-md;
    border: 1px solid var(--border-lighter);

    .filter-form {
        display: flex;
        flex-wrap: wrap;
        gap: $spacing-md;

        .el-form-item {
            margin-bottom: 0;
        }
    }
}

// 工具栏
.toolbar-section {
    display: flex;
    gap: $spacing-sm;
    margin-bottom: $spacing-md;

    .upload-inline {
        display: inline-block;
    }
}

// 表格区域
.table-section {
    .word-table {
        width: 100%;
        border-radius: $border-radius-sm;
        overflow: hidden;

        ::v-deep th {
            background: var(--bg-elevated);
            color: var(--text-primary);
            font-weight: 600;
        }

        ::v-deep td {
            color: var(--text-regular);
        }
    }
}

// 编辑对话框
::v-deep .edit-dialog {
    .el-dialog__header {
        background: var(--gradient-header);
        border-bottom: 1px solid var(--border-lighter);
        padding: $spacing-md $spacing-lg;

        .el-dialog__title {
            font-weight: 600;
            color: var(--text-primary);
        }
    }

    .el-dialog__body {
        padding: $spacing-lg;
    }

    .el-dialog__footer {
        padding: $spacing-md $spacing-lg;
        border-top: 1px solid var(--border-lighter);
    }
}

// 响应式适配
@media (max-width: $screen-md) {
    .game-manage-container {
        padding: $spacing-md;
    }

    .settings-section {
        padding: $spacing-md;
    }

    .filter-section {
        .filter-form {
            flex-direction: column;
        }
    }

    .toolbar-section {
        flex-wrap: wrap;
    }
}

@media (max-width: $screen-sm) {
    .game-tabs {
        ::v-deep .el-tabs__item {
            padding: 0 $spacing-md;
            font-size: $font-size-sm;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/game/manage/index.vue